import { IComponentStateTheme, TComponentState } from '../types/index'

export const handleComponentStateTheme = (state: TComponentState): IComponentStateTheme => {
  switch (state) {
    case 'primary':
      return {
        backgroundColor: '#F4F0FF',
        borderColor: '#F4F0FF',
        color: '#A86EEB'
      }
    case 'success':
      return {
        backgroundColor: '#EEFFFB',
        borderColor: '#EEFFFB',
        color: '#22cfae'
      }
    case 'warning':
      return {
        backgroundColor: '#FFF9D8',
        borderColor: '#FFF9D8',
        color: '#FFD002'
      }
    case 'error':
      return {
        backgroundColor: '#FFEAED',
        borderColor: '#FFEAED',
        color: '#FF627B'
      }
    default:
      return {
        backgroundColor: '#F0F0F0',
        borderColor: '#F0F0F0',
        color: '#B0B0B0'
      }
  }
}
